<template>
  <CustomFormBuilder :template-id="templateId" />
</template>

<script setup lang="ts">
import { getPathValueAt } from "@/lib/url.js";

import CustomFormBuilder from "./CustomFormBuilder.vue";

// Path is /company/custom_forms/:id/edit — the id sits at segment index 2
// (getPathValueAt drops the leading empty segment). We read it here rather than
// $route.params to match the app's other edit pages.
const raw = getPathValueAt(2);
const templateId = raw ? Number(raw) : null;
</script>
